export default "__VITE_ASSET__Isz34_oW__"